__turbopack_context__.v({
  "ctaButtons": "LBSttG_ctaButtons",
  "heroContent": "LBSttG_heroContent",
  "heroImage": "LBSttG_heroImage",
  "heroTextContent": "LBSttG_heroTextContent",
  "root": "LBSttG_root",
});
